<template>
  <span>
      <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <button class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm" @click="back">
                Back 
            </button>
        </div>

         <div class="row">
            <div class="col-12">     
                    <div class="col-xl-8">
                        <div class="card shadow mb-4">
                          <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-primary">Agreements</h6>
                          </div>
                            <div class="card-body">
                                <div class="col-12 mb-4" v-if="agreements.length === 0">
                                  <div class="card border-left-primary shadow h-100 py-2">
                                    <div class="card-body">
                                      <div class="row no-gutters align-items-center">
                                        <div class="col mr-2">
                                          <div class="text-xs font-weight-bold text-primary text-uppercase mb-1"></div>
                                          <div class="h5 mb-0 font-weight-bold text-gray-800">
                                            <p class="p-5">No Agreement Available</p> 
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-12 mb-4" v-for="(agreement, key) in agreements" :key="key" v-else>
                                  <div class="card border-left-primary shadow h-100 py-2">
                                    <div class="card-body">
                                      <div class="row no-gutters align-items-center">
                                        <div class="col mr-2">
                                          <div class="text-xs font-weight-bold text-primary text-uppercase mb-1"></div>
                                          <div class="h5 mb-0 font-weight-bold text-gray-800">
                                             <p> <span class="text-success">Category Name: </span>{{agreement.category_name}}</p>
                                             <p>File <a href="`${url()}/api/${agreement.file}`" download="">Pdf</a></p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="card-footer">
                                        <div class="">
                                            <p>Created By: {{agreement.user_name}}</p>
                                        </div>
                                        <div class="col-auto">
                                          <button class="btn btn-primary btn-sm mr-2"
                                            type="button" data-toggle="modal" data-target="#exampleModal"
                                             @click="confirmDelete(agreement.id,key, 'isDelete')"
                                             >delete</button>
                                             <button class="btn btn-success btn-sm"
                                              type="button" data-toggle="modal" data-target="#exampleModal"
                                             @click="confirmApproval(agreement.id,key, 'isApprove')"
                                             v-if="!agreement.approved">approve</button>
                                             <button class="btn btn-sm btn-success disabled" :disabled='agreement.approved' 
                                             v-else>approved</button>
                                             
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                          </div>
                
              </div>
          </div><!--- end of pills content -->
          <!--- start of delete modal --->
          <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel" v-if="isDelete">
                      Do you Really Want To Delete This Category?
                  </h5>
                  <h5 class="modal-title" id="exampleModalLabel" v-else-if="isApprove">
                      Confirm Approval?
                  </h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                    <p v-if="success" class="text">{{success}}</p>
                </div>
                <div class="modal-footer" v-if="isDelete">
                  <button type="button" class="btn btn-primary" @click="deleteAgreement">Yes</button>
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
                </div>    
                <div class="modal-footer" v-else-if="isApprove">
                  <button type="button" class="btn btn-primary" @click="approveAgreement">Approve</button>
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Decline</button>
                </div>
              </div>
            </div>
          </div>
          <!--- end of delete modal box --->
        </div>
  </span>
</template>

<script>
export default {
    props: ['id','name'],

    data(){
      return {
        isDelete: false,
        isApprove:false,
        key:'',
        agreement_id:'',
      }
    },
    methods:{
        back(){
            this.$router.push('/editor_dashboard/home')
        },
        confirmDelete(id,key){
            this.agreement_id = id;
            this.key = key;
            this.isApprove = false;
            this.isDelete = true;
        },
        confirmApproval(id, key){
            this.agreement_id = id;
            this.key = key;
            this.isDelete = false;
            this.isApprove = true;
        },
        approveAgreement(){
            this.$store.dispatch('approveAgreement', {id:this.agreement_id,key: this.key})
        },
         deleteAgreement(){
           this.$store.dispatch('deleteAgreement', {id:this.agreement_id, key:this.key})
         }
    },
    computed:{
        agreements() {
            return this.$store.state.editor.agreements
        },
        success() {
          return this.$store.state.editor.success;
        },
        loading(){
          return this.$store.state.editor.loading
        }
    },
    created(){
        this.$store.dispatch('getAgreements',this.id)
    }
}
</script>

<style>

</style>